const settings = {
    useSSO: true
}

export default settings